export var eventsList = {
    offerActivated: "offerActivated",
    offerHideModal: "offerHideModal",
    offerMatch: "offerMatch",
    login: "login",
    findUser: "findUser",
};
